import Swiper from 'swiper/bundle';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const activites = {
    swiperGalerie: null,
    galerieItems: [],
    galerieIndex: 0,

    init() {
        this.initSwipers();
        this.initProgramme();
        this.initGalerieModal();
        this.initFilters();
        this.initRessourcesGate();
    },
    initRessourcesGate() {
        const STORAGE_KEY = 'arbor_ressources_unlocked';

        const RESSOURCES_FORM_IDS = [
            'bc90dd5a-1472-48f6-bafa-fc814d706c7d',
            'e851352b-eac4-4dd9-a46B-1b4d8524d74a'
        ];

        const gate = document.querySelector('._hubspot_gate');
        const ressources = document.querySelector('._ressources_columns');

        if (!gate || !ressources) return;

        const unlockRessources = () => {
            gate.style.display = 'none';
            ressources.classList.add('_show');
            localStorage.setItem(STORAGE_KEY, '1');
        };

        const isRessourcesForm = (formId) => {
            if (!formId) return false;
            return RESSOURCES_FORM_IDS.includes(formId);
        };

        const getHubspotFormId = (event) => {
            const detail = event.detail || {};
            const instance = detail.instance;

            return (
                detail.formId ||
                detail.formGuid ||
                detail.id ||
                instance?.getFormId?.() ||
                null
            );
        };

        if (localStorage.getItem(STORAGE_KEY) === '1') {
            unlockRessources();
            return;
        }

        window.removeEventListener('hs-form-event:on-submission:success', window._arborHubspotUnlock);

        window._arborHubspotUnlock = function (event) {
            const formId = getHubspotFormId(event);

            //console.log('HS SUBMISSION SUCCESS FORM ID', formId);

            if (isRessourcesForm(formId)) {
                unlockRessources();
            }
        };

        window.addEventListener('hs-form-event:on-submission:success', window._arborHubspotUnlock);

        $(window)
            .off('message.initRessourcesGate')
            .on('message.initRessourcesGate', function (event) {
                const data = event.originalEvent.data;

                const formId =
                    data?.formId ||
                    data?.formGuid ||
                    data?.id ||
                    null;

                //console.log('HS MESSAGE EVENT', data);

                if (
                    data &&
                    data.type === 'hsFormCallback' &&
                    data.eventName === 'onFormSubmitted' &&
                    isRessourcesForm(formId)
                ) {
                    unlockRessources();
                }
            });
    },
    initFilters() {
        const section = document.querySelector('section.__section_actualites');

        if (!section) return;

        const filters = section.querySelectorAll('._contain_filters [data-filter]');
        const items = section.querySelectorAll('article._actualite[data-cat]');

        if (!filters.length || !items.length) return;

        const applyFilter = (filter = 'all') => {
            filters.forEach(filterEl => {
                filterEl.classList.toggle('_activ', filterEl.dataset.filter === filter);
            });

            items.forEach(item => {
                const cat = item.dataset.cat;
                item.style.display = (filter === 'all' || cat === filter) ? '' : 'none';
            });
        };

        $(document)
            .off('click.initActualitesFilters')
            .on('click.initActualitesFilters', 'section.__section_actualites ._contain_filters [data-filter]', function () {
                applyFilter(this.dataset.filter || 'all');
            });

        applyFilter('all');
    },

    initSwipers() {
        if (this.swiperGalerie) {
            this.swiperGalerie.destroy(true, true);
            this.swiperGalerie = null;
        }

        const $galerie = document.querySelector('.__galerie_swipe');

        if (!$galerie) {
            return;
        }

        this.swiperGalerie = new Swiper('.__galerie_swipe', {
            direction: 'horizontal',
            spaceBetween: 30,
            breakpoints: {
                0: {
                    slidesPerView: 1.1,
                    spaceBetween: 10,
                },
                600: {
                    slidesPerView: 1.4,
                    spaceBetween: 10,
                },
                900: {
                    slidesPerView: 2.3,
                    spaceBetween: 20,
                },
                1300: {
                    slidesPerView: 2.5,
                }
            }
        });
    },

    initProgramme() {
        $(document)
            .off('click.initProgramme', '._programme > h3')
            .on('click.initProgramme', '._programme > h3', function () {
                let _elt = $(this).parent();
                _elt.toggleClass('_open');
                $('._programme').not(_elt).removeClass('_open');
            });
    },

    initGalerieModal() {
        const self = this;

        self.refreshGalerieItems();

        $(document)
            .off('click.initGalerieModal', '.js-galerie-item')
            .on('click.initGalerieModal', '.js-galerie-item', function () {
                self.refreshGalerieItems();
                self.galerieIndex = self.galerieItems.indexOf(this);
                self.openGalerie();
            });

        $(document)
            .off('click.closeGalerieModal', '.js-close-galerie')
            .on('click.closeGalerieModal', '.js-close-galerie', function () {
                self.closeGalerie();
            });

        $(document)
            .off('click.prevGalerieModal', '.js-galerie-prev')
            .on('click.prevGalerieModal', '.js-galerie-prev', function (e) {
                e.stopPropagation();
                self.prevGalerie();
            });

        $(document)
            .off('click.nextGalerieModal', '.js-galerie-next')
            .on('click.nextGalerieModal', '.js-galerie-next', function (e) {
                e.stopPropagation();
                self.nextGalerie();
            });

        $(document)
            .off('keydown.galerieModal')
            .on('keydown.galerieModal', function (e) {
                const $modal = document.querySelector('.__modal_galerie');

                if (!$modal || !$modal.classList.contains('_open')) {
                    return;
                }

                if (e.key === 'Escape') {
                    self.closeGalerie();
                }

                if (e.key === 'ArrowLeft') {
                    self.prevGalerie();
                }

                if (e.key === 'ArrowRight') {
                    self.nextGalerie();
                }
            });
    },

    refreshGalerieItems() {
        this.galerieItems = Array.from(document.querySelectorAll('.js-galerie-item'));
    },

    openGalerie() {
        const modal = document.querySelector('.__modal_galerie');
        if (!modal || !this.galerieItems.length) {
            return;
        }

        this.updateGalerieImage();
        modal.classList.add('_open');
        modal.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('_modal_open');
        document.body.classList.add('_modal_open');
    },

    closeGalerie() {
        const modal = document.querySelector('.__modal_galerie');
        if (!modal) {
            return;
        }

        modal.classList.remove('_open');
        modal.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('_modal_open');
        document.body.classList.remove('_modal_open');
    },

    updateGalerieImage() {
        const modalImg = document.querySelector('.js-galerie-full-img');
        const currentItem = this.galerieItems[this.galerieIndex];

        if (!modalImg || !currentItem) {
            return;
        }

        const full = currentItem.getAttribute('data-full');
        const alt = currentItem.getAttribute('data-alt') || '';

        modalImg.setAttribute('src', full);
        modalImg.setAttribute('alt', alt);
    },

    prevGalerie() {
        if (!this.galerieItems.length) {
            return;
        }

        this.galerieIndex = (this.galerieIndex - 1 + this.galerieItems.length) % this.galerieItems.length;
        this.updateGalerieImage();
    },

    nextGalerie() {
        if (!this.galerieItems.length) {
            return;
        }

        this.galerieIndex = (this.galerieIndex + 1) % this.galerieItems.length;
        this.updateGalerieImage();
    },

    destroy() {
        $(document).off('click.initProgramme', '._programme > h3');
        $(document).off('click.initGalerieModal', '.js-galerie-item');
        $(document).off('click.closeGalerieModal', '.js-close-galerie');
        $(document).off('click.prevGalerieModal', '.js-galerie-prev');
        $(document).off('click.nextGalerieModal', '.js-galerie-next');
        $(document).off('keydown.galerieModal');
        $(document).off('click.initActualitesFilters', '.__contain_filters [data-filter]');
        $(window).off('message.initRessourcesGate');

        $(window).off('message.initRessourcesGate');

        if (window._arborHubspotUnlock) {
            window.removeEventListener('hs-form-event:on-submission:success', window._arborHubspotUnlock);
        }

        if (this.swiperGalerie) {
            this.swiperGalerie.destroy(true, true);
            this.swiperGalerie = null;
        }

        this.closeGalerie();
    }
};

export default activites;